import { connect } from 'react-redux';

import {
  setSendToEmail,
  setSendToEmailSecondary,
  setSendToEmailBool,
  setCompanyPhone,
  setMessageType,
  setEinvoiceAddress,
  setPoNumber
} from 'redux/modules/invoice';
import Invoicing from './invoicing';

const mapStateToProps = ({invoice, user}) => ({
  invoice,
  user
});

const mapDispatchToProps = {
  setSendToEmail,
  setSendToEmailSecondary,
  setSendToEmailBool,
  setCompanyPhone,
  setMessageType,
  setEinvoiceAddress,
  setPoNumber
};

const InvoicingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Invoicing);

export default InvoicingContainer;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/invoicing/index.js
 **/